<div
  *ngIf="!is_list_running"
  class="sp-width__full sp-min-height__full sp-column">
  
  <div class="sp-row__align sp-wrap sp-margin__bottom">
    <app-shared-pill
      content="{{ this.total }} {{ 'GENERAL.RESULTS_LABEL' | translate }}"
      [content_class]="'sp-color__accent-contrast'"
      [pill_class]="'sp-background__accent'"></app-shared-pill>
  </div>

  <app-orders-data-table
    *ngIf="orders?.length"
    class="sp-width__full"
    [orders]="orders || []"
    (refresh)="refresh.emit()"
    (scrolledToEnd)="onScrollEnd()"></app-orders-data-table>

  <!--<div
    *ngIf="cursor"
    #orders_load_more
    class="sp-width__full sp-row__center">
    <app-shared-button
      [button_class]="'sp-button__plain sp-width__fit-content sp-margin__top-x2'"
      [spinner_class]="'sp-spinner__secondary'"
      [cta]="'GENERAL.LOAD_MORE_CTA'"
      [is_disabled]="is_load_more_running"
      [is_spinner_visible]="is_load_more_running"
      (button_click)="onLoadMoreClick()"></app-shared-button>
  </div>-->
</div>

<app-loading *ngIf="is_list_running"></app-loading>
